import React from 'react';

import { Tool } from '../../components/common/editor/Utilities.jsx';

import { MessageLink } from '../../components/repositories/Type.jsx';

import { PageBottomHiddenDraggable, PageTopHiddenDraggable } from '../utility/blocks';
import { withBlockRendering } from '../utility/BuilderBlock.jsx';
import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import TypeConfig from '../utility/TypeConfig.jsx';

import { BaseButton } from './Button.jsx';
import Comment from './Comment.jsx';
import { InventoryMetaTypeConfig } from './InventoryMeta.jsx';

function _InventoryCellContainerComponent(props) {
    const columnWidth = props.width || 200;
    let maxWidth = columnWidth;
    if (props.columnCount > 1) {
        let cellPadding = parseInt(props.cellPadding, 10);
        if (isNaN(cellPadding)) {
            cellPadding = InventoryCellContainerTypeConfig.defaultCellPadding;
        }
        maxWidth -= (2 * cellPadding);
    }
    let blocks;
    if (props.contentConfig && props.contentConfig.blocks && props.contentConfig.blocks.length > 0) {
        blocks = props.contentConfig.blocks;
    }
    if (!blocks) {
        blocks = InventoryCellContainerTypeConfig.defaultDesign({}).blocks;
    }
    let content = props.onBlockRendering(
        blocks,
        (d) => {
            if (!d.type) {
                return;
            }
            switch (d.type.value) {
                case Name.Block.Column:
                    return { columnWidth, inCell: true, maxWidth, serverSide: props.serverSide };
                case Name.Block.Inventory.Button:
                    return { columnWidth, maxWidth };
                case Name.Block.Inventory.Image:
                    return { columnWidth, inCell: true, maxWidth };
                case Name.Block.Inventory.Text:
                    return { columnWidth, inCell: true, maxWidth };
            }
        },
        () => ({ renderDragOutline: props.editor == true }));
    const bodyProps = {
        style: {
            borderCollapse: 'collapse',
            display: 'inline-table',
            msoTableLspace: '0pt',
            msoTableRspace: '0pt',
            msTextSizeAdjust: '100%',
            WebkitTextSizeAdjust: '100%'
        }
    };
    if (props.builder) {
        bodyProps.className = 'builder';

        if (props.editor) {
            bodyProps.className += ' builder-editor';
            if (props.dragging) {
                bodyProps.className += ' dragging';
            }
            bodyProps.id = 'dropArea';
            bodyProps.style.width = '100%';
            bodyProps.onDragEnter = props.onDragEnter;
            bodyProps.onDrop = props.onDrop;
            bodyProps.onDragOver = (e) => {
                if (e) {
                    e.preventDefault();
                }
            };
            content = (
                <>
                    <PageTopHiddenDraggable pageEmpty={!content || content.length == 0} onDragEnter={props.onDragEnter} />
                    {content}
                    <PageBottomHiddenDraggable onDragEnter={props.onDragEnter} />
                </>
            )
        } else {
            bodyProps.style.pointerEvents = 'none';
        }
    }
    return (
        <>
            {
                props.renderMso &&
                <Comment document={props.frameDoc} id={`${props.blockId}-${props.index}-top`} value={`<!--[if (gte mso 9)|(IE)]><td align="center" valign="top" width="${columnWidth}" style="width:${columnWidth}px;"><![endif]-->`} />
            }
            <table
                align={props.alignment}
                border="0"
                cellPadding="0"
                cellSpacing="0"
                className="columnWrapper"
                width={columnWidth}
                {...bodyProps}>
                <tbody>
                    <tr>
                        <td
                            className="columnContainer"
                            style={{
                                msoLineHeightRule: 'exactly',
                                msTextSizeAdjust: '100%',
                                WebkitTextSizeAdjust: '100%'
                            }}
                            valign="top">
                            {content}
                        </td>
                    </tr>
                </tbody>
            </table>
            {
                props.renderMso &&
                <Comment document={props.frameDoc} id={`${props.blockId}-${props.index}-bottom`} value={`<!--[if (gte mso 9)|(IE)]></td><![endif]-->`} />
            }
        </>
    );
}
const InventoryCellContainerComponent = withBlockRendering(_InventoryCellContainerComponent);
const InventoryCellContainerTypeConfig = {
    defaultCellPadding: 18,
    defaultDesign: ({ cropImage, linkType }) => {
        return {
            "blocks": [
                {
                    "config": {
                        "block": {
                            "isCropped": cropImage,
                            "linkType": linkType || MessageLink.Campaign.Custom
                        },
                        "layout": {
                            "paddingTop": {
                                "unit": "px",
                                "value": "9"
                            }
                        }
                    },
                    "id": `${Name.Block.Inventory.Image}-${Tool.generateUniqueId()}`,
                    "type": {
                        "value": Name.Block.Inventory.Image
                    }
                },
                {
                    "config": {
                        "block": {
                            "design": InventoryMetaTypeConfig.defaultDesign()
                        },
                        "layout": {
                            "paddingTop": {
                                "unit": "px",
                                "value": "9"
                            }
                        }
                    },
                    "id": `${Name.Block.Inventory.Text}-${Tool.generateUniqueId()}`,
                    "type": {
                        "value": Name.Block.Inventory.Text
                    }
                },
                {
                    "config": {
                        "block": {
                            "borderRadius": {
                                "unit": "px",
                                "value": "3"
                            },
                            "buttonColor": TypeConfig.defaultBackgroundColor,
                            "color": "#ffffff",
                            "design": "Buy Now",
                            "fontFamily": TypeConfig.defaultFontFamily,
                            "fontSize": {
                                "value": "16",
                                "unit": "px"
                            },
                            "isBold": true,
                            "isItalic": false,
                            "isUnderline": false,
                            "linkType": linkType || MessageLink.Campaign.Custom,
                            "textAlign": "center"
                        },
                        "layout": {
                            "marginBottom": {
                                "unit": "px",
                                "value": "18"
                            },
                            "marginTop": {
                                "unit": "px",
                                "value": "18"
                            },
                            "paddingBottom": {
                                "unit": "px",
                                "value": "15"
                            },
                            "paddingLeft": {
                                "unit": "px",
                                "value": "15"
                            },
                            "paddingRight": {
                                "unit": "px",
                                "value": "15"
                            },
                            "paddingTop": {
                                "unit": "px",
                                "value": "15"
                            }
                        }
                    },
                    "id": `${Name.Block.Inventory.Button}-${Tool.generateUniqueId()}`,
                    "type": {
                        "value": Name.Block.Inventory.Button
                    }
                }
            ]
        }
    },
    defaultDesignTransactional: () => {
        return {
            "blocks": [
                {
                    "config": {
                        "block": {
                            "columnCount": "1",
                            "borderRadius": {
                                "unit": "px",
                                "value": "7"
                            },
                            "borderTopStyle": "solid",
                            "borderTopWidth": {
                                "unit": "px",
                                "value": "4"
                            },
                            "borderTopColor": "rgba(242,242,242,1)",
                            "borderBottomColor": "rgba(242,242,242,1)",
                            "borderLeftColor": "rgba(242,242,242,1)",
                            "borderRightColor": "rgba(242,242,242,1)",
                            "borderBottomStyle": "solid",
                            "borderLeftStyle": "solid",
                            "borderRightStyle": "solid",
                            "borderBottomWidth": {
                                "unit": "px",
                                "value": "4"
                            },
                            "borderLeftWidth": {
                                "unit": "px",
                                "value": "4"
                            },
                            "borderRightWidth": {
                                "unit": "px",
                                "value": "4"
                            }
                        },
                        "layout": {
                            "height": {
                                "unit": "px",
                                "value": "320"
                            },
                            "valign-col1": "middle",
                            "valign-col2": "middle",
                            "paddingTop": {
                                "unit": "px",
                                "value": ""
                            }
                        }
                    },
                    "dataType": "layout",
                    "id": `${Name.Block.Column}-${Tool.generateUniqueId()}`,
                    "type": {
                        "value": Name.Block.Column
                    },
                    "blocks": [
                        [
                            {
                                "config": {
                                    "block": {
                                        "isCropped": false
                                    },
                                    "layout": {
                                        "paddingBottom": {
                                            "value": "",
                                            "unit": "px"
                                        },
                                        "paddingTop": {
                                            "value": "27",
                                            "unit": "px"
                                        },
                                        "paddingLeft": {
                                            "unit": "px",
                                            "value": "81"
                                        },
                                        "paddingRight": {
                                            "unit": "px",
                                            "value": "81"
                                        }
                                    }
                                },
                                "id": `${Name.Block.Inventory.Image}-${Tool.generateUniqueId()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Image
                                }
                            },
                            {
                                "config": {
                                    "block": {
                                        "design": `<p style="margin-left:0;text-align:left;"><span class="custom-color" style="color:#4e4e4e;font-family:verdana,sans-serif;font-size:15px;font-weight:bold;line-height:17px;vertical-align:middle;" token="${Token.Inventory.Artist}">{${Token.Inventory.Artist}("before":"","after":"")}</span></p><p style="margin-left:0;text-align:left;"><span class="custom-color" style="color:#4e4e4e;display:inline;font-family:verdana,sans-serif;font-size:15px;font-style:italic;line-height:17px;vertical-align:middle;" token="${Token.Inventory.Title}">{${Token.Inventory.Title}("before":"","after":"")}</span><span class="custom-color" style="color:#4e4e4e;display:inline;font-family:verdana,sans-serif;font-size:15px;line-height:17px;vertical-align:middle;" token="${Token.Inventory.Date}">{${Token.Inventory.Date}("before":", ","after":"")}</span></p><p style="margin-left:0;text-align:left;"><span class="custom-color" style="color:#9a9a9a;font-family:verdana,sans-serif;font-size:15px;line-height:17px;vertical-align:middle;" token="${Token.Inventory.Medium}">{${Token.Inventory.Medium}("before":"","after":"")}</span></p><p style="margin-left:0;text-align:left;"><span class="custom-color" style="color:#9a9a9a;font-family:verdana,sans-serif;font-size:15px;line-height:17px;vertical-align:middle;" token="${Token.Inventory.Dimensions}">{${Token.Inventory.Dimensions}("before":"","after":"")}</span></p><p style="margin-left:0;text-align:left;"><span class="custom-color" style="color:#9a9a9a;font-family:verdana,sans-serif;font-size:15px;line-height:17px;vertical-align:middle;" token="${Token.Inventory.Price}">{${Token.Inventory.Price}("before":"","after":"")}</span></p>`
                                    },
                                    "layout": {
                                        "paddingBottom": {
                                            "value": "27",
                                            "unit": "px"
                                        },
                                        "paddingTop": {
                                            "value": "18",
                                            "unit": "px"
                                        },
                                        "paddingLeft": {
                                            "unit": "px",
                                            "value": "81"
                                        },
                                        "paddingRight": {
                                            "unit": "px",
                                            "value": "81"
                                        }
                                    }
                                },
                                "id": `${Name.Block.Inventory.Text}-${Tool.generateUniqueId()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Text
                                }
                            }
                        ]
                    ]
                }
            ]
        }
    }
}
const InventoryCellContainer = { Component: InventoryCellContainerComponent, TypeConfig: InventoryCellContainerTypeConfig };

// #region INVENTORY BUTTON

function InventoryButtonComponent(props) {
    const data = props.data || {};
    const containerInsideStyle = { minWidth: props.maxWidth };
    let inventoryLink;
    if (props.blockConfig && props.blockConfig.block) {
        if (props.blockConfig.block.backgroundColor) {
            containerInsideStyle.backgroundColor = props.blockConfig.block.backgroundColor;
        }
        switch (props.blockConfig.block.linkType) {
            case MessageLink.Campaign.Custom:
                inventoryLink = props.blockConfig.block.url;
                break;
            case MessageLink.Campaign.ArtsyMarketplace:
                inventoryLink = data.ArtsyMarketplaceUrl;
                break;
            case MessageLink.Campaign.Marketplace:
                inventoryLink = data.MarketplaceUrl;
                break;
            case MessageLink.Campaign.Website:
                inventoryLink = data.WebsiteUrl;
                break;
        }
    }
    const handleShouldMapStyleConfigProp = (propName) => {
        switch (propName) {
            case 'backgroundColor':
            case 'linkType':
                return false;
            default:
                return true;
        }
    }
    return (
        <table align="center" border="0" cellPadding="0" cellSpacing="0" width={props.columnWidth}>
            <tbody>
                <tr>
                    <td align="center" valign="top">
                        <table
                            border="0"
                            cellPadding="0"
                            cellSpacing="0"
                            className={props.className}
                            style={containerInsideStyle}
                            width={props.maxWidth}>
                            <tbody style={{ backgroundColor: containerInsideStyle.backgroundColor }}>
                                <tr>
                                    <BaseButton.Component
                                        {...props}
                                        defaultText={InventoryButtonTypeConfig.defaultText()}
                                        link={inventoryLink}
                                        useWrapper={false}
                                        onShouldMapStyleConfigProp={handleShouldMapStyleConfigProp} />
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    )
}
const InventoryButtonTypeConfig = {
    defaultText: () => 'Buy Now',
    panel: {
        // The default serves the bundles without a DOM; the campaign builder passes the gated name.
        block: function (isArtsy, marketplaceName = 'ArtCloud Marketplace') {
            const config = BaseButton.TypeConfig.panel.block(InventoryButtonTypeConfig.defaultText());
            config.options.splice(0, 0,
                {
                    display: 'Inventory Link',
                    group: config.group,
                    name: 'linkType',
                    options: [
                        ...MessageLink.optionsCampaign(isArtsy, marketplaceName, 'display'),
                        { display: 'Custom Link...', value: MessageLink.Campaign.Custom }
                    ],
                    type: 'dropdown',
                    value: 'marketplace'
                },
                {
                    display: 'Custom Link',
                    fullWidth: true,
                    group: config.group,
                    name: 'url',
                    type: 'text',
                    visible: (config) => config.block && config.block.linkType == MessageLink.Campaign.Custom
                }
            );
            return config;
        },
        layout: BaseButton.TypeConfig.panel.layout
    }
}
const InventoryButtonBlockTypeDefinition = (group, isArtsy, marketplaceName) => {
    return {
        id: Name.Block.Inventory.Button,
        config: {
            block: InventoryButtonTypeConfig.panel.block(isArtsy, marketplaceName),
            layout: InventoryButtonTypeConfig.panel.layout()
        },
        display: 'Inventory Button',
        group,
        image: 'button.png'
    };
}
const InventoryButton = { BlockTypeDefinition: InventoryButtonBlockTypeDefinition, Component: InventoryButtonComponent, TypeConfig: InventoryButtonTypeConfig };

// #endregion INVENTORY BUTTON

export {
    InventoryButton,
    InventoryCellContainer
};